import { useTranslation } from "react-i18next";
import nothingAnimation from "assets/images/animations/nothing.json";

const DeletedEvent = () => {
  const { t } = useTranslation();

  return (
    <div className="container-fluid px-4 pt-5 pb-4 bg-white">
      <div className="row justify-content-center">
        <div className="col-xl-4 col-lg-6 col-md-8 col-sm-8">
          <div className="text-center">
            <div className="mt-5" style={{ maxWidth: "500px", width: "100%", margin: "0 auto" }}>
              <lottie-player
                src={JSON.stringify(nothingAnimation)}
                background="transparent"
                speed="1"
                // style={{ width: "100%", height: "auto" }}
                loop
                autoplay
              ></lottie-player>
            </div>

            <p
              className="mt-3 fs-4 fw-bold"
            >
              {t("Event is deleted")}
            </p>
            <p
            >
              {t("Please contact your photographer or event manager for more information.")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletedEvent;